import { render, staticRenderFns } from "./WorkflowSection.vue?vue&type=template&id=56abbd32&"
import script from "./WorkflowSection.vue?vue&type=script&lang=ts&"
export * from "./WorkflowSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports